
import './Home.css';
import background from '../../assests/internship/intern-background-home.png';
import google from '../../assests/internship/google.png';
import certifiacte from '../../assests/internship/certifatetion.png';
import Header from '../componets/header/header';
import Footer from '../componets/footer/footer';
import { Button, Card, Carousel, Form, Input, notification } from 'antd';
import home1 from "../../assests/home1.webp";
import home2 from "../../assests/home2.webp";
import home3 from "../../assests/home3.png";
import about from "../../assests/about_image.png";
import { WhatsAppOutlined, FacebookFilled, InstagramOutlined, YoutubeOutlined, LinkedinFilled, GoogleOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { API } from '../../config/api';
import { POST } from '../../utils/apicalls';
import person2 from "../../assests/internship/person2.png";
const Home = () => {
    const [isLoading, setIsLoading] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const submitHandler = async (values: any) => {
        try {
            let obj = {
                visitorsId: values.visitorsId,
                type: "visitor",
                visitors_name: values.visitors_name,
                date: values.date || new Date().toISOString(),
                visitors_email: values.visitors_email,
                visitors_purpose: "from website",
                employee_id: 1,
                visitors_phone: values.visitors_phone,
                description: values.description,
                altPhone: values.altPhone,
            };

            setIsLoading(true);
            const api = API.CREATE_VISITORS;
            const postRequest: any = await POST(api, obj);
            if (postRequest.status) {
                notification.success({ message: "visitors created successfully!" });
                setIsLoading(false);
                setIsModalOpen(false);
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };
    const [animate, setAnimate] = useState(false);
    const reviews = [
        {
            name: "Jestin J George",
            review: "I had the incredible opportunity to work as a student intern at Papa Digital Solutions in Kochi...",
            image: "https://i.pravatar.cc/100?img=1",
        },
        {
            name: "Vyshna Jayaraj",
            review: "Studied Digital Marketing online class in Papa Digital Solution in Kochi. Great experience!",
            image: "https://i.pravatar.cc/100?img=2",
        },
        {
            name: "Eldho V",
            review: "Good experience with Papa Digital Solutions. Offline classes with live project experience.",
            image: "https://i.pravatar.cc/100?img=3",
        },
        {
            name: "Anjali M",
            review: "Amazing faculty and support throughout the course. Highly recommend Papa Digital Academy.",
            image: "https://i.pravatar.cc/100?img=4",
        },
        {
            name: "Arya",
            review: "Great training experience and very supportive instructors. Learned a lot at Papa Digital.",
            image: "https://i.pravatar.cc/100?img=5",
        },
        {
            name: "Alif",
            review: "Papa Digital provides excellent hands-on training in digital marketing. Highly recommend!",
            image: "https://i.pravatar.cc/100?img=6",
        },
        {
            name: "Swaraj",
            review: "Enjoyed the live projects and interactive sessions. Great place to learn practical skills.",
            image: "https://i.pravatar.cc/100?img=7",
        },
        {
            name: "Rishad",
            review: "Supportive mentors and detailed sessions. A perfect start for my digital journey.",
            image: "https://i.pravatar.cc/100?img=8",
        },
        {
            name: "Yousaf",
            review: "Learned digital tools with real-time projects. Papa Digital is a great platform to start.",
            image: "https://i.pravatar.cc/100?img=9",
        },
        {
            name: "Mujeeb",
            review: "Experienced excellent training and guidance from the instructors at Papa Digital Solutions.",
            image: "https://i.pravatar.cc/100?img=10",
        },
        {
            name: "Vishnnu",
            review: "Amazing environment and well-organized course modules. Thank you Papa Digital!",
            image: "https://i.pravatar.cc/100?img=11",
        },
        {
            name: "Aneesh PN",
            review: "I loved the practical approach and friendly teaching style. Great experience overall.",
            image: "https://i.pravatar.cc/100?img=12",
        },
        {
            name: "Aneeshmarwa",
            review: "Trainers are well-qualified and sessions were very interactive. Highly recommend it.",
            image: "https://i.pravatar.cc/100?img=13",
        },
        {
            name: "Meharunisa",
            review: "Had an amazing learning journey. Papa Digital gave me the confidence to grow.",
            image: "https://i.pravatar.cc/100?img=14",
        },
        {
            name: "Therasa",
            review: "A perfect institute for learning digital marketing. Excellent staff and course structure.",
            image: "https://i.pravatar.cc/100?img=15",
        },
    ];

    useEffect(() => {
        setAnimate(true);
    }, []);
    const settings = {
        autoplay: true,
        autoplaySpeed: 1000,
        dots: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768, // on mobile, show 1
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };
    return (
        <><Header />
            <div>
                <section className="hero">
                    <div className="text_values">
                        <b>Creators | Advertisers | People</b>
                        <h1>Kerala Best Agency Based Digital Marketing Academy</h1>


                        <div className="social-icons">
                            <a href='https://www.facebook.com/papadigitalsolution' target="_blank" rel="noopener noreferrer">
                                <FacebookFilled style={{ color: "white" }} />
                            </a>
                            <a href='https://www.instagram.com/pda_kochi?igsh=MWRpemtpamRkOWp6Mg==' target="_blank" rel="noopener noreferrer">
                                <InstagramOutlined className="fab fa-instagram" style={{ color: "white" }} />
                            </a>
                            <a href='https://www.youtube.com/@Papadigitalsolution' target="_blank" rel="noopener noreferrer">
                                <YoutubeOutlined className="fab fa-youtube" style={{ color: "white" }} />
                            </a>
                            <a href='https://www.linkedin.com/company/papa-digital-solution/posts/?feedView=all' target="_blank" rel="noopener noreferrer">
                                <LinkedinFilled className="fab fa-linkedin-in" style={{ color: "white" }} />
                            </a>
                            <a href='https://wa.me/9562121008' target="_blank" rel="noopener noreferrer">
                                <WhatsAppOutlined className="fab fa-whatsapp" style={{ color: "white" }} />
                            </a>
                        </div>
                    </div>

                    <img src={background} alt="Group of Students" style={{
                        position: 'absolute',
                        bottom: 0,
                        maxWidth: '100%',
                        height: 'auto',
                        zIndex: 2,
                    }} />


                </section>
                <div className="scroll-wrapper">
                    <div className="scroll-inner">
                        🎓 Online Courses&nbsp;&nbsp;|&nbsp;&nbsp;🏫 Offline Courses&nbsp;&nbsp;|&nbsp;&nbsp;📚 Learn Anytime, Anywhere&nbsp;&nbsp;|&nbsp;&nbsp;✅ Government-Approved Certification&nbsp;&nbsp;|&nbsp;&nbsp;👨‍🏫 Expert Trainers&nbsp;&nbsp;|&nbsp;&nbsp;🕐 Flexible Batch Timings&nbsp;&nbsp;|&nbsp;&nbsp;💼 100% Placement Support&nbsp;&nbsp;|&nbsp;&nbsp;📍 Kerala, India
                    </div>
                </div>


                <div >
                    <div>
                        <div className="stats-row">
                            <div className="stat-box" data-aos="fade-up">
                                <span className="stat-value">500+</span>
                                <h5 className="stat-label">HAPPY STUDENTS</h5>
                            </div>
                            <div className="stat-box" data-aos="fade-up" data-aos-delay="100">
                                <span className="stat-value">400+</span>
                                <h5 className="stat-label">PLACED STUDENTS</h5>
                            </div>
                            <div className="stat-box" data-aos="fade-up" data-aos-delay="200">
                                <span className="stat-value">50+</span>
                                <h5 className="stat-label">TEAM MEMBERS</h5>
                            </div>
                            <div className="stat-box" data-aos="fade-up" data-aos-delay="300">
                                <span className="stat-value">7+</span>
                                <h5 className="stat-label">YEARS OF EXPERIENCE</h5>
                            </div>
                        </div>

                    </div>
                    <div >
                        <div className="internship-card-section">
                            <div className="internship-card dark">
                                <div className="internship-card-content">

                                    <h3>Digital Marketing Course</h3>
                                    <p>
                                        Learn SEO, social media, paid ads, and analytics with real-world projects. Gain hands-on experience from one of the top digital marketing academies in Kochi.
                                    </p>
                                    <Button href="/internship" className="hoverEffect">
                                        Apply Now
                                    </Button>
                                </div>
                            </div>

                            <div className="internship-card light">
                                <div className="internship-card-content">

                                    <h3>Online Live Digital Marketing Program</h3>
                                    <p>
                                        Understand how to build and position brands effectively. Develop your creative and strategic thinking through guided mentorship.
                                    </p>
                                    <Button href="/internship" className="hoverEffect">
                                        Apply Now
                                    </Button>
                                </div>
                            </div>

                            <div className="internship-card dark">
                                <div className="internship-card-content">
                                    <h3>On-Site Digital Marketing</h3>
                                    <p>
                                        Learn SEO, social media marketing, Google Ads, email campaigns, and analytics through live projects. Build in-demand skills with real-time, in-house training.
                                    </p>
                                    <Button href="/Internshiponsite" className="hoverEffect">
                                        Apply Now
                                    </Button>
                                </div>

                            </div>

                        </div>
                        <Button href="/courses" className="view-all-btn" style={{ width: "200px" }}>
                            View All Courses
                        </Button>
                    </div>
                </div>
                <section className="course-audience-section">
                    <h2>WHO SHOULD ATTEND THE COURSE</h2>
                    <div className="audience-cards-container">
                        <div className="audience-card">
                            <span className="card-number">1</span>
                            <h3>For Students & Graduates</h3>
                            <h4>Jumpstart Your Career!</h4>
                            <p>
                                Are you ready to be the next in-demand Digital Marketing Professional? Dive into our comprehensive
                                courses designed to catapult you into the job market with the hottest digital skills under your belt.
                                Let's turn your potential into success!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">2</span>
                            <h3>For Homemakers</h3>
                            <h4>Reignite Your Career Path!</h4>
                            <p>
                                Thinking of re-entering the workforce or starting fresh? Our flexible digital marketing programs are perfect for
                                gaining the skills you need at your own pace. Empower yourself to step back into your career with confidence
                                and creativity!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">3</span>
                            <h3>For Working Professionals</h3>
                            <h4>Advance Your Career!</h4>
                            <p>
                                Feel stuck in your current role? It's time to up-skill and make a leap towards that dream career with our
                                cutting-edge digital marketing training. Enhance your resume and your prowess, and watch new doors
                                open as you transform your professional life!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">4</span>
                            <h3>For Entrepreneurs</h3>
                            <h4>Skyrocket Your Business!</h4>
                            <p>
                                Ready to take your business to the next level? Learn how to attract high-ticket clients and significantly
                                boost your revenue through targeted, effective digital marketing strategies. Join us and start seeing your
                                business grow like never before!
                            </p>
                        </div>
                        <div className="audience-card">
                            <span className="card-number">5</span>
                            <h3>For Web Development Enthusiasts</h3>
                            <h4>Build the Digital Future!</h4>
                            <p>
                                Interested in creating stunning websites and powerful web applications? Our courses provide the foundational
                                and advanced skills in web development to turn your ideas into reality. Whether you're a beginner or looking
                                to expand your expertise, join us to master the art of web development!
                            </p>
                        </div>
                        <div className="audience-card">
                            <span className="card-number">6</span>
                            <h3>For Digital & Social Media Users</h3>
                            <h4>Level Up Your Online Presence!</h4>
                            <p>
                                Do you spend time on social media or use digital tools daily? Transform your basic knowledge into powerful
                                skills! Discover how to strategically use digital platforms for personal branding, community building, or even
                                to kickstart a new venture. Unlock the full potential of the digital world!
                            </p>
                        </div>
                    </div>
                </section>
                <div className="about-section-wrapper">
                    <div className="about-left">

                        <div className="course-item full-width">
                            <img src={person2} className="responsive-image" alt="Descriptive Alt Text" />
                            <Card style={{ textAlign: "center", background: "blue", color: "white", fontSize: "20px" }}>
                                Need More Help<br />
                                <a style={{ color: "white" }}>+91 - 9562121008</a>
                            </Card>
                        </div>
                    </div>


                    <div className="about-right">
                        <h6 className="about-subtitle">About Us</h6>
                        <h2 className="about-title">
                            WHO WE ARE
                        </h2>
                        <div className="about-summary">

                            <div className="about-description">
                                <p>
                                    At Papa Digital Academy, we are more than just a technology company - we are your trusted
                                    partners in navigating the digital landscape.
                                    Our mission is to empower businesses and individuals by providing innovative, tailored digital
                                    solutions that drive growth, efficiency, and success.
                                </p>
                                <p>
                                    Founded on the principles of creativity, collaboration, and customer-centricity, we pride
                                    ourselves on delivering exceptional value through cutting-edge technology and expert
                                    guidance. Our parent company is helmed by marketing professionals with more than 5+ years
                                    of experience in creative marketing and tech realms. With such vast expertise behind us, papa
                                    digital solution aims to become the go-to destination for students, job seekers, and
                                    professionals looking to boost their digital marketing skills and career prospects.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>

                <div >
                    <div className="feature-section" >
                        <h2 className="feature-title">
                            HAPPY STORIES
                        </h2>
                        <h3>Papa Digital Marketing Course Experiences</h3>
                    </div>
                    <section className={`google-review-section ${animate ? "fade-in-up" : ""}`}>
                        <div className="google-review-container">
                            {/* Fixed Rating Block */}
                            <div className="rating-block">
                                <h2>EXCELLENT</h2>
                                <div className="stars">★★★★★</div>
                                <p>Based on <strong>329 reviews</strong></p>
                                <a href='https://g.page/r/CbRFMcSqif3CEAE/review' target="_blank" rel="noopener noreferrer">
                                    <img src={google} alt="Google" />
                                </a>
                            </div>

                            <div className="carousel-wrapper scrollable-carousel">
                                <Carousel {...settings}>
                                    {reviews.map((item, index) => (
                                        <div key={index}>
                                            <div className="review-card-carousel">
                                                <GoogleOutlined style={{ color: "red", fontSize: 20, position: "absolute", top: 10, right: 10 }} />
                                                <img src={item.image} alt={item.name} className="review-avatar" />
                                                <p className="name">{item.name}</p>
                                                <div className="stars">★★★★★</div>
                                                <p className="text">{item.review}</p>
                                            </div>
                                        </div>
                                    ))}
                                </Carousel>
                            </div>
                        </div>
                    </section>

                </div>
                <div className="whatweoffer-container">
                    <div className="offer-image">
                        <img src={about} alt="What We Offer" />
                    </div>
                    <div className="offer-content">
                        <h2>Why Join Us?</h2>
                        <ul>
                            <li> Real-world experience through live projects</li>
                            <li> Mentorship from industry experts</li>
                            <li>Flexible learning for students, professionals, and entrepreneurs</li>
                            <li>Opportunities to grow in digital marketing and beyond</li>
                            <p>At papa digital Academy, we believe in the power of innovation and the
                                importance of quality education. Join us, and let's build a bright, successful
                                future together!</p>
                        </ul>
                    </div>
                </div>
                <section className="certifications-section">
                    <div className="cert-left">
                        <img src={certifiacte} alt="Certificate Holder" className="cert-image" />
                    </div>
                    <div className="cert-right">
                        <h2 className="cert-title">CERTIFICATIONS</h2>
                        <p className="cert-description">
                            At <strong>Papa Digital Academy</strong>, we equip you with industry-recognized digital marketing certifications that are accepted worldwide.
                            Our certification programs are designed in collaboration with leading platforms like Google, HubSpot, and SEMrush.
                        </p>
                        <p className="cert-description">
                            By completing our Advanced Digital Marketing Program, you will not only gain hands-on experience but also earn internationally valid certificates
                            that boost your professional credibility and job opportunities.
                        </p>
                        <p className="cert-description">
                            Join us to become a certified digital marketer and unlock global career possibilities.
                        </p>

                    </div>
                </section>
                <div className="blog-section">
                    <h2 className="blog-title">BEST DIGITAL MARKETING BLOGS</h2>

                    <div className="blog-cards">
                        {[
                            {
                                image: home1,
                                title: "The Digital Marketing for Modern Businesses",
                                desc: "Stay ahead of the curve with the latest digital marketing strategies tailored for modern businesses.",
                                link: "/blog1"
                            },
                            {
                                image: home2,
                                title: "Digital Marketing Goodness",
                                desc: "Explore the key principles that make digital marketing work for your business.",
                                link: "/blog2"
                            },
                            {
                                image: home3,
                                title: "Welcome to the Offbeat Digital Marketing",
                                desc: "Discover the unconventional yet effective strategies that are transforming digital marketing.",
                                link: "/blog3"
                            },
                        ].map((card, index) => (
                            <div className="blog-card" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="blog-img-wrapper">
                                    <img src={card.image} alt={card.title} className="blog-img" />
                                </div>

                                <div className="blog-content">
                                    <h4 className="blog-heading">{card.title}</h4>
                                    <p className="blog-desc">{card.desc}</p>
                                    <a href={card.link} className="blog-read-btn">Read More →</a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div>
                    <div className="contact-container" >
                        <div className="contact-left">
                            <p className="highlight-text">CONTACT WITH US</p>
                            <h1>LET’S WORK TOGETHER?</h1>
                            <p className="description">
                                Sed ut perspiciatis unde omnis natus error sit voluptatem accusantium doloremque laudantium totam rem.
                            </p>
                            <div className="contact-info">
                                <div className="info-box">
                                    <div className="icon">📞</div>
                                    <div>
                                        <p className="info-title">HAVE ANY QUESTION?</p>
                                        <p>Free <a style={{ textDecoration: "none", color: "black" }} href='tel:+919562121008'>+91 956 2121 008</a></p>
                                    </div>
                                </div>
                                <div className="info-box">
                                    <div className="icon">✉️</div>
                                    <div>
                                        <p className="info-title">SEND EMAIL</p>
                                        <p>
                                            <a style={{ textDecoration: "none", color: "black" }} href='mailto:admin@papadigitalacademy.com'>admin@papadigitalacademy.com</a>
                                        </p>
                                    </div>
                                </div>
                                <div className="info-box">
                                    <div className="icon">📍</div>
                                    <div>
                                        <p className="info-title">VISIT ANYTIME</p>
                                        <p> Kuzhikkattumoola, Kakkanad, Kochi, Kerala</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="contact-right">
                            <h2>CONTACT US</h2>
                            <Form
                                form={form}
                                name="contact_form"
                                onFinish={submitHandler}
                                layout="vertical"
                                style={{ maxWidth: "600px", margin: "0 auto" }}
                            >
                                <Form.Item
                                    name="visitors_name"
                                    label="Your Name"
                                    rules={[{ required: true, message: "Please enter your name" }]}
                                >
                                    <Input placeholder="Your Name" />
                                </Form.Item>

                                <Form.Item
                                    name="visitors_email"
                                    label="Email Address"
                                    rules={[{ required: true, type: "email", message: "Enter valid email" }]}
                                >
                                    <Input placeholder="Email Address" />
                                </Form.Item>

                                <Form.Item
                                    name="visitors_phone"
                                    label="Phone Number"
                                    rules={[{ required: true, message: "Please enter your phone number" }]}
                                >
                                    <Input placeholder="Phone Number" />
                                </Form.Item>

                                <Form.Item
                                    name="altPhone"
                                    label="Subject"
                                    rules={[{ required: true, message: "Please enter the subject" }]}
                                >
                                    <Input placeholder="Subject" />
                                </Form.Item>

                                <Form.Item
                                    name="description"
                                    label="Comment"
                                    rules={[{ required: true, message: "Please enter your comment" }]}
                                >
                                    <Input.TextArea placeholder="Comment" rows={4} />
                                </Form.Item>

                                <Form.Item>
                                    <Button type="primary" htmlType="submit" loading={isLoading}>
                                        WRITE A MESSAGE
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Home;
